/* eslint-disable camelcase */
import PropTypes from 'prop-types';

const propTypesSliceQuoteLine = {
  quote_line_slice_id: PropTypes.string,
  quote_line_content: PropTypes.string.isRequired,
  quote_line_author: PropTypes.string,
};

export const propTypesDataQuoteLine = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceQuoteLine),
};
